<shared-forklift-right-route-header [detail]="detail"></shared-forklift-right-route-header>
<options *ngIf="detail" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>

<shared-active-slots-item-driverplate [route]="route" *ngIf="option=='DRIVERPLATE'"
    (refresh)="onRouteRefresh($event)"></shared-active-slots-item-driverplate>